const actions = {
  GET_SINGLE_PROMO_BEGIN: 'GET_SINGLE_PROMO_BEGIN',
  GET_SINGLE_PROMO_SUCCESS: 'GET_SINGLE_PROMO_SUCCESS',
  GET_SINGLE_PROMO_ERR: 'GET_SINGLE_PROMO_ERR',

  RESET_SINGLE_PROMO_DATA: 'RESET_SINGLE_PROMO_DATA',

  GET_ALL_PROMOS_BEGIN: 'GET_ALL_PROMOS_BEGIN',
  GET_ALL_PROMOS_SUCCESS: 'GET_ALL_PROMOS_SUCCESS',
  GET_ALL_PROMOS_ERR: 'GET_ALL_PROMOS_ERR',

  DISABLE_PROMO_BEGIN: 'DISABLE_PROMO_BEGIN',
  DISABLE_PROMO_SUCCESS: 'DISABLE_PROMO_SUCCESS',
  DISABLE_PROMO_ERR: 'DISABLE_PROMO_ERR',

  ADD_PROMO_BEGIN: 'ADD_PROMO_BEGIN',
  ADD_PROMO_SUCCESS: 'ADD_PROMO_SUCCESS',
  ADD_PROMO_ERR: 'ADD_PROMO_ERR',

  EDIT_PROMO_BEGIN: 'EDIT_PROMO_BEGIN',
  EDIT_PROMO_SUCCESS: 'EDIT_PROMO_SUCCESS',
  EDIT_PROMO_ERR: 'EDIT_PROMO_ERR',

  getSinglePromoBegin: () => {
    return {
      type: actions.GET_SINGLE_PROMO_BEGIN,
    };
  },

  getSinglePromoSuccess: (data) => {
    return {
      type: actions.GET_SINGLE_PROMO_SUCCESS,
      data,
    };
  },

  getSinglePromoErr: (err) => {
    return {
      type: actions.GET_SINGLE_PROMO_ERR,
      err,
    };
  },

  getAllPromosBegin: () => {
    return {
      type: actions.GET_ALL_PROMOS_BEGIN,
    };
  },

  getAllPromosSuccess: (data) => {
    return {
      type: actions.GET_ALL_PROMOS_SUCCESS,
      data,
    };
  },

  getAllPromosErr: (err) => {
    return {
      type: actions.GET_ALL_PROMOS_ERR,
      err,
    };
  },

  addPromoBegin: () => {
    return {
      type: actions.ADD_PROMO_BEGIN,
    };
  },

  addPromoSuccess: (data) => {
    return {
      type: actions.ADD_PROMO_SUCCESS,
      data,
    };
  },

  addPromoErr: (err) => {
    return {
      type: actions.ADD_PROMO_ERR,
      err,
    };
  },

  disablePromoBegin: () => {
    return {
      type: actions.DISABLE_PROMO_BEGIN,
    };
  },

  disablePromoSuccess: (data) => {
    return {
      type: actions.DISABLE_PROMO_SUCCESS,
      data,
    };
  },

  disablePromoErr: (err) => {
    return {
      type: actions.DISABLE_PROMO_ERR,
      err,
    };
  },

  editPromoBegin: () => {
    return {
      type: actions.EDIT_PROMO_BEGIN,
    };
  },

  editPromoSuccess: (data) => {
    return {
      type: actions.EDIT_PROMO_SUCCESS,
      data,
    };
  },

  editPromoErr: (err) => {
    return {
      type: actions.EDIT_PROMO_ERR,
      err,
    };
  },

  resetSinglePromoData: () => {
    return {
      type: actions.RESET_SINGLE_PROMO_DATA,
    };
  },
};

export default actions;
